import { DateObject } from '@uplift/services';


export const abbreviateMonth = (date: DateObject): string => {
  return {
    January: 'Jan.',
    February: 'Feb.',
    March: 'Mar.',
    April: 'Apr.',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'Aug.',
    September: 'Sep.',
    October: 'Oct.',
    November: 'Nov.',
    December: 'Dec.',
  }[date.format('MMMM')];
};
